import React from "react";
import logo from "./assets/logo.png";
import bottomAlign from "./assets/align/bottom.png"
import topAlign from "./assets/align/top.png"
import leftAlign from "./assets/align/left.png"
import rightAlign from "./assets/align/right.png"
import searchIcon from "./assets/search.png";

import {Scrollbars} from 'react-custom-scrollbars';

const defaultState = {
    controls: {
        fontSize: 25,
        letterSpacing: "0px",
        textTransform: "none",
        lineHeight: "30px",
        textAlign: "center",
    },
    logoSize: 100,
    logoMargin: 10,
    text: "LogoText",
    searchText: "",
    align: "bottom",
    logosPerRow:4
}

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState
        }
    }


    applyChange() {
        this.props.applyChange(this.state);
    }


    getStyleForAlign(type) {
        if (type === this.state.align) {
            return "border-blue";
        }

        return "border-black";
    }

    logosPerRowStyle(divNumber) {
        if (this.state.logosPerRow >= divNumber) {
            return "bg-blue text-white border-blue";
        } else {
            return "bg-white text-blue border-blue";
        }
    }


    render() {

        const lineHeight = this.state.controls.lineHeight;
        const letterSpacing = this.state.controls.letterSpacing;

        return (
            <div>
                <div style={{
                    position: "fixed",
                    top: 0,
                    width: "100%",
                    zIndex: 9,
                    backgroundColor: "white",
                    left: 0,
                    right: 0
                }}>

                    <div
                        className="flex flex-row w-full items-center justify-between px-8 py-4 h-auto shadow-1 search-bar">
                        <img alt="Logo" src={logo} className="h-8"/>
                        <form className="h-full relative" onSubmit={(evt) => {
                            evt.preventDefault();
                            this.props.searchText(this.state.searchText);
                            return false;
                        }
                        }>
                            <input className="h-full py-2 border-b border-grey" type="text" placeholder="Search"
                                   value={this.state.searchText}
                                   onChange={(evt) => {
                                       this.setState({searchText: evt.target.value})
                                       this.props.searchText(evt.target.value);
                                   }}/>
                            <img
                                alt="Search"
                                className="absolute pin-r pin-b mb-2 p-1 cursor-pointer opacity-50"
                                src={searchIcon} width={24}
                                onClick={() => this.props.searchText(this.state.searchText)}/>
                        </form>
                    </div>


                </div>

                {this.props.logoURL !== "" &&

                    <Scrollbars className="shadow-1 sidebar" style={{
                        position: "fixed",
                        width: 240,
                        paddingRight: 10,
                        zIndex: 8,
                        top: 60,
                        right: 0,
                        bottom: 0,
                        paddingTop: 30,
                        marginBottom: 50,
                        backgroundColor: "white"
                    }}>
                        <div className="shadow-1 sidebar" style={{}}>

                            <div className="flex flex-col relative align-center justify-center">


                                <div className="m-6">
                                    <h3 className="mb-4">Align</h3>
                                    <div className="flex flex-row">
                                        <div
                                            className={"w-1/4 mr-1 border-2 rounded cursor-pointer " + this.getStyleForAlign("bottom")}>
                                            <img alt="Bottom" width="100%" className="border-black border rounded"
                                                 src={bottomAlign}
                                                 onClick={() => this.setState({align: "bottom"})}/>
                                        </div>

                                        <div
                                            className={"w-1/4 mr-1 border-2 rounded cursor-pointer " + this.getStyleForAlign("top")}>
                                            <img alt="Top" width="100%" className="border-black border rounded"
                                                 src={topAlign}
                                                 onClick={() => this.setState({align: "top"})}/>
                                        </div>

                                        <div
                                            className={"w-1/4 mr-1 border-2 rounded cursor-pointer " + this.getStyleForAlign("left")}>
                                            <img alt="Left" width="100%" className="border-black border rounded"
                                                 src={leftAlign}
                                                 onClick={() => this.setState({align: "left"})}/>
                                        </div>

                                        <div
                                            className={"w-1/4 border-2 rounded cursor-pointer " + this.getStyleForAlign("right")}>
                                            <img alt="Right" width="100%" className="border-black border rounded"
                                                 src={rightAlign}
                                                 onClick={() => this.setState({align: "right"})}/>
                                        </div>
                                    </div>

                                </div>

                                <div className="m-6">
                                    <h3 className="mb-4">Logo per row</h3>
                                    <div className="flex flex-row h-8">
                                        <a
                                            className={"w-1/4 text-center pt-1 mr-1 h-full border-2 rounded cursor-pointer " + this.logosPerRowStyle(1)}
                                                 onClick={() => this.setState({logosPerRow: 1})}>
                                            1
                                        </a>

                                        <a
                                            className={"w-1/4 text-center pt-1 mr-1 h-full border-2 rounded cursor-pointer "  + this.logosPerRowStyle(2)}
                                                 onClick={() => this.setState({logosPerRow: 2})}>
                                            2
                                        </a>

                                        <a
                                            className={"w-1/4 text-center pt-1 mr-1 h-full border-2 rounded cursor-pointer "  + this.logosPerRowStyle(3)}
                                                 onClick={() => this.setState({logosPerRow: 3})}>
                                            3
                                        </a>

                                        <a
                                            className={"w-1/4 text-center pt-1 mr-1 h-full border-2 rounded cursor-pointer "  + this.logosPerRowStyle(4)}
                                                 onClick={() => this.setState({logosPerRow: 4})}>
                                            4
                                        </a>
                                    </div>

                                </div>


                                <div className="m-6">
                                    <h3 className="mb-4">Text</h3>

                                    <textarea rows="3" name="name" placeholder="LogoText"
                                              value={this.state.text.replace(/<br\s?\/?>/g, "\n")}
                                              onChange={(evt) => this.setState({text: evt.target.value.replace(/\r\n|\r|\n/g, "<br />")})}/>
                                </div>


                                <div className="m-6">
                                    <h3 className="mb-4">Text Transform</h3>

                                    <select onChange={(evt) => this.setState({
                                        controls: {
                                            ...this.state.controls,
                                            textTransform: evt.target.value
                                        }
                                    })} value={this.state.controls.textTransform}>
                                        <option value="none">None</option>
                                        <option value="uppercase">UPPERCASE</option>
                                        <option value="lowercase">lowercase</option>
                                        <option value="capitalize">Capitalize</option>
                                    </select>

                                </div>


                                <div className="m-6">
                                    <h3 className="mb-4">Font Size</h3>: <span
                                    className="border-none">{this.state.controls.fontSize}px</span>
                                    <div className="range-slider">
                                        <input className="range-slider__range" type="range" name="fontSize" step="1"
                                               min="1"
                                               max="50"
                                               value={this.state.controls.fontSize} onChange={(evt) => this.setState({
                                            controls: {
                                                ...this.state.controls,
                                                fontSize: parseInt(evt.target.value, 10)
                                            }
                                        })}/>
                                    </div>

                                </div>


                                <div className="m-6">
                                    <h3 className="mb-4">Text Align</h3>

                                    <select onChange={(evt) => this.setState({
                                        controls: {
                                            ...this.state.controls,
                                            textAlign: evt.target.value
                                        }
                                    })} value={this.state.controls.textAlign}>
                                        <option value="left">Left</option>
                                        <option value="center">Center</option>
                                        <option value="right">Right</option>
                                    </select>

                                </div>

                                <div className="m-6">
                                    <h3 className="mb-4">Line Height</h3>: <span
                                    className="border-none">{lineHeight}</span>

                                    <div className="range-slider">
                                        <input className="range-slider__range" type="range" name="lineHeight" step="1"
                                               min="1" max="50"
                                               value={parseInt(lineHeight.replace("px", ""), 10)}
                                               onChange={(evt) => this.setState({
                                                   controls: {
                                                       ...this.state.controls,
                                                       lineHeight: evt.target.value + "px"
                                                   }
                                               })}/>
                                    </div>

                                </div>

                                <div className="m-6">
                                    <h3 className="mb-4">Letter Spacing</h3>: <span
                                    className="border-none">{letterSpacing}</span>

                                    <div className="range-slider">
                                        <input className="range-slider__range" type="range" name="lineHeight" step="1"
                                               min="1" max="10"
                                               value={parseInt(letterSpacing.replace("px", ""), 10)}
                                               onChange={(evt) => this.setState({
                                                   controls: {
                                                       ...this.state.controls,
                                                       letterSpacing: evt.target.value + "px"
                                                   }
                                               })}/>
                                    </div>

                                </div>

                                <div className="m-6">
                                    <h3 className="mb-4">Logo Size</h3>: <span
                                    className="border-none">{this.state.logoSize}px</span>

                                    <div className="range-slider">
                                        <input className="range-slider__range" type="range" name="logoSize" step="1"
                                               min="100" max="300"
                                               value={this.state.logoSize}
                                               onChange={(evt) => this.setState({logoSize: parseInt(evt.target.value, 10)})}/>
                                    </div>

                                </div>

                                <div className="m-6">
                                    <h3 className="mb-4">Logo Spacing</h3>: <span
                                    className="border-none">{this.state.logoMargin}px</span>
                                    <div className="range-slider">
                                        <input className="range-slider__range" type="range" name="logoMargin" step="1"
                                               min="1" max="100"
                                               value={this.state.logoMargin}
                                               onChange={(evt) => this.setState({logoMargin: parseInt(evt.target.value, 10)})}/>
                                    </div>
                                </div>

                                <div className="m-6 cursor-pointer">
                                    <a className="text-center cursor-pointer border-b border-blue"
                                       onClick={() => this.setState({...defaultState}, () => {
                                           this.applyChange();
                                           this.props.searchText(this.state.searchText);
                                           this.props.onClear();
                                       })}>Clear</a>
                                </div>

                                <div className="m-6">

                                    <a className="inline-block shadow-1 w-1/2 mx-auto cursor-pointer text-white p-2 bg-blue hover:bg-blue-darker text-center w-full"
                                       onClick={() => {
                                           const callPrint = true;
                                           window.onPrint(callPrint);
                                       }}>Print</a></div>

                                <div className="h-32"/>


                                <a style={{width: 250}}
                                   className="fixed pin-b bg-blue hover:bg-blue-darker cursor-pointer text-center text-white p-4"
                                   onClick={() => this.applyChange()}>
                                    Apply
                                </a>

                            </div>

                        </div>
                    </Scrollbars>
                }


            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Header.js